/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Row_Session_MinutesInputs */

const en_us2_profile_row_session_minutes = /** @type {(inputs: Profile_Row_Session_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Length of each workout`)
};

const pt_br2_profile_row_session_minutes = /** @type {(inputs: Profile_Row_Session_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração de cada treino`)
};

const es_419_profile_row_session_minutes = /** @type {(inputs: Profile_Row_Session_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración de cada entrenamiento`)
};

const pt_pt2_profile_row_session_minutes = /** @type {(inputs: Profile_Row_Session_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração de cada treino`)
};

const fr_fr2_profile_row_session_minutes = /** @type {(inputs: Profile_Row_Session_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée de chaque séance`)
};

const de_de2_profile_row_session_minutes = /** @type {(inputs: Profile_Row_Session_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer pro Training`)
};

const it_it2_profile_row_session_minutes = /** @type {(inputs: Profile_Row_Session_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata di ogni allenamento`)
};

/**
* | output |
* | --- |
* | "Length of each workout" |
*
* @param {Profile_Row_Session_MinutesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_row_session_minutes = /** @type {((inputs?: Profile_Row_Session_MinutesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Row_Session_MinutesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_row_session_minutes(inputs)
	if (locale === "es-419") return es_419_profile_row_session_minutes(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_row_session_minutes(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_row_session_minutes(inputs)
	if (locale === "de-DE") return de_de2_profile_row_session_minutes(inputs)
	if (locale === "it-IT") return it_it2_profile_row_session_minutes(inputs)
	return en_us2_profile_row_session_minutes(inputs)
});
export { profile_row_session_minutes as "profile.row_session_minutes" }